import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useActiveStateSelector } from '../../../../../containers/customizer.duck';
import GridLayout from '../../../../../components/common/GridLayout';
import useCarouselItemConfig from '../../../../../hooks/useCarouselItemConfig';
import { IS_TAB } from '../../../../../utils/common';
import Carousel from '../../../../../components/common/Carousel';

const Model = ({
  options,
  allCategoryCustomizations,
  initialSelectedCustomizationIndex,
  allBikeArtData,
  currentActiveParent,
  updatePartsConfig,
  selectedAngle,
  selectedPart,
  partsConfig
}) => {
  // const [activeModel, setActiveModel] = useState(
  //   initialSelectedCustomizationIndex
  // );

  // useActiveStateSelector('frontBikeArt', options, partsConfig, setActiveModel);

  // useEffect(() => {
  //   setActiveModel(initialSelectedCustomizationIndex);
  // }, [initialSelectedCustomizationIndex]);

  // const availableParts = options.map(entry => entry.partId);

  // const selectedModel = Object.keys(partsConfig.bikeArt).find(
  //   key => availableParts.includes(key) && partsConfig.bikeArt[key] === true
  // );
  const viewCode = currentActiveParent === 'front' ? 'F' : 'B';

  const selectedModel = selectedAngle.configData.linkBack.model;

  const { ref: cardRef, width: cardWidth } = useCarouselItemConfig();

  return (
    <div className="model">
      {IS_TAB ? (
        <Carousel noOfItems={options && options.length} itemWidth={cardWidth}>
          {options.map((option, i) => (
            <div
              ref={cardRef}
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`model-image  ${selectedModel === option.partId &&
                'model-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                // setActiveModel(i);
                updatePartsConfig(
                  options[i],
                  'bikeArt',
                  allBikeArtData
                    .filter(
                      cust =>
                        !cust.customizationType ||
                        (cust.customizationType === 'angle' &&
                          cust.partId[cust.partId.length - 1] !== viewCode) ||
                        cust.customizationType === 'color'
                    )
                    .map(cust => cust.partId)
                );
              }}
            />
          ))}
        </Carousel>
      ) : (
        <GridLayout columns={3}>
          {options.map((option, i) => (
            <div
              role="presentation"
              onKeyDown={() => {}}
              key={option.id}
              className={`model-image  ${selectedModel === option.partId &&
                'model-image-selected'}`}
              style={{ backgroundImage: `url(${option.configData.thumbnail})` }}
              onClick={() => {
                // setActiveModel(i);
                updatePartsConfig(
                  options[i],
                  'bikeArt',
                  allBikeArtData
                    .filter(
                      cust =>
                        !cust.customizationType ||
                        (cust.customizationType === 'angle' &&
                          cust.partId[cust.partId.length - 1] !== viewCode) ||
                        cust.customizationType === 'color'
                    )
                    .map(cust => cust.partId)
                );
              }}
            />
          ))}
        </GridLayout>
      )}
    </div>
  );
};

Model.propTypes = {
  options: PropTypes.array,
  initialSelectedCustomizationIndex: PropTypes.number,
  updatePartsConfig: PropTypes.func,
  partsConfig: PropTypes.object
};

export default Model;
